// @flow
import * as React from 'react';
import Ghost from '../../../../../components/ghost/Ghost';

import './styles/ContentGhost.scss';

function ContentGhost() {
    return (
        <div className="ContentGhost">
            <Ghost className="ContentGhost-title" height={24} width={280} />
            <Ghost className="ContentGhost-body" height={80} />
            <div className="ContentGhost-footer">
                <Ghost className="ContentGhost-dateGhost" height={20} width={96} />
                <Ghost className="ContentGhost-linkGhost" height={20} width={96} />
            </div>
        </div>
    );
}

export default ContentGhost;
